const findAnswer = (complaint, kind) =>
  complaint?.complaintAnswers?.find((answer) => answer?.kind === kind) ||
  'Indefinido'

export default findAnswer
